(function($) {
    'use strict';

    var submitHandler = function(status) {
        var showElement = $(this).data('ajax-success-show');
        var hideElement = $(this).data('ajax-success-hide');

        if (status !== 200) {
            showElement = $(this).data('ajax-failure-show');
            hideElement = $(this).data('ajax-failure-hide');
        }

        if (showElement) {
            $(showElement).not('.modal').show();
            $(showElement).filter('.modal').modal('show');
        }

        if (hideElement) {
            $(hideElement).not('.modal').hide();
            $(hideElement).filter('.modal').modal('hide');
        }
    }

    var errorHandler = function(errors) {
        if (errors && typeof errors === 'object') {
            var ref = $(this);

            ref.find('.has-error')
                .removeClass('has-error');

            ref.find('.invalid-feedback').remove();

            Object.keys(errors).forEach(function(key) {
                let message = errors[key];

                ref.find('[name="' + key + '"]')
                    .addClass('has-error')
                    .after($('<span />')
                        .addClass('invalid-feedback d-block')
                        .html(message[0]));
            });

        }
        if (grecaptcha && grecaptcha.reset instanceof Function) {
            grecaptcha.reset();
        }

    }

    /**
     * Example usages:
     * - Publish profile
     * - Coach personal message
     */
    jQuery(document).on('submit', '[data-ajax-url]', function(e) {
        var _this = this;
        var api_route = $(this).data('ajax-url');
        var data = new FormData(this);
        var action = $(this).data('action');

        e.preventDefault();

        if (! api_route) {
            return;
        }

        var url = cfpluginvars.api_uri + api_route;

        if (action != null) {
            url = cfpluginvars.ajax_url;
            data.append('action', action);
            data.append('api_route', api_route)
        }

        data.append('blog_id', cfpluginvars.blog_id)

        $(this).addClass('form--loading');

        $(this).find(':submit').prop('disabled', true);

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: url,
            data: data,
            processData: false,
            contentType: false,
        }).done(function(response, textStatus, jqXHR) {
            var formType = data.get('_form');
            if( formType && formType == 'personalMessageQuestion' ) {
                $('.send-message-success').append('<div class="personal-message-question-event-success"></div>');
            }

            if( formType && formType == 'personalMessageContact' ) {
                $('.send-message-success').append('<div class="personal-message-event-success"></div>');
            }

            submitHandler.apply(_this, [jqXHR.status]);
        }).success(function(data) {
            if(data.redirect) {
                window.location.href = data.redirect;
            }

        }).fail(function(jqXHR, textStatus, errorThrown) {
            submitHandler.apply(_this, [jqXHR.status]);
            errorHandler.apply(_this, [jqXHR.responseJSON ? (jqXHR.responseJSON.errors || {}) : {}])

            $(_this).find(':submit').prop('disabled', false);
            $(_this).removeClass('form--loading');
        }).always(function() {
            $(_this).find(':submit').prop('disabled', false);
            $(_this).removeClass('form--loading');
        });
    });
})(jQuery);